module.exports = __webpack_public_path__ + "img/template.f82bb388.png";